import { empApi } from "./client";

// =============================================================
// API Báo cáo thống kê (KPI nhân viên) - FEv1 cổng nhân viên.
// Khớp endpoint app (backend-v1 proxy document/MSH). Phạm vi do BE lọc theo token.
// Chi tiết KPI 1 nhân viên tái dùng getMyKpiDetailApi({month,year,code}) (evaluation.api.js).
// =============================================================
const BASE = "/document/api/v2/msh/evaluations";

// Danh sách KPI nhân viên khối kinh doanh theo tháng -> { summary, items, pagination }
export const getEmployeeKpiListApi = (params) =>
  empApi.get(`${BASE}/sale-kpis/monthly`, params);

// Cập nhật nhận xét của quản lý cho 1 nhân viên/tháng
export const updateLeaderCommentApi = (payload) =>
  empApi.patch(`${BASE}/leader-comment`, payload);

// ===== KPI khối (khớp BlockKpiApiEndPoint của app) =====
export const getBlockKpiListApi = (params) => empApi.get(`${BASE}/block-kpis/monthly`, params);

export const getBlockKpiDetailApi = (params) =>
  empApi.get(`${BASE}/block-kpis/monthly/detail`, params);
